import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
  partnerType: [validator('belongs-to'), validator('presence', true)],
  tradeTypes: [validator('has-many'), validator('presence', true)],
});

export default class TradePartnerModel extends Model.extend(Validations) {
  @attr('boolean') chartable;
  @attr('string') city;
  @attr('string') cityEn;
  @attr('string') email;
  @attr('string') name;
  @attr('string') phone;
  @attr('string') street;
  @attr('string') zipcode;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('category', { async: true, inverse: null }) country;
  @belongsTo('link', { async: true, inverse: null }) link;
  @belongsTo('category', { async: true, inverse: null }) partnerType;
  @belongsTo('category', { async: true, inverse: null }) region;
  @hasMany('category', { async: true, inverse: null }) tradeTypes;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }
}
